import { formatAmount } from '@/lib/core';
import { SoldOutTag } from '../list/banners/sold-out-tag';

/** Shared product image + sold-out overlay, used by both the shop listing grid and the favorites grid. */
export function ProductCardMedia({
  imageUrl,
  alt,
  soldOut,
  imageBgClassName = 'bg-jncquoi-neutral-200',
  onClick,
}: {
  imageUrl?: string;
  alt?: string;
  soldOut?: boolean;
  imageBgClassName?: string;
  onClick?: () => void;
}) {
  return (
    <div
      className={`relative h-65 w-full shrink-0 overflow-hidden ${imageBgClassName}`}
      onClick={onClick}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={alt ?? ''}
          className="pointer-events-none absolute inset-0 h-full w-full object-cover"
        />
      )}
      {soldOut && (
        <>
          <div className="absolute inset-0 bg-[rgba(204,204,204,0.6)]" />
          <SoldOutTag className="absolute top-2 left-2" />
        </>
      )}
    </div>
  );
}

/** Shared vendor / title / price block, used by both the shop listing grid and the favorites grid. */
export function ProductCardInfo({
  vendor,
  title,
  price,
  locale,
}: {
  vendor?: string | null;
  title?: string | null;
  price?: number;
  locale: string;
}) {
  return (
    <div className="flex min-w-px flex-1 flex-col items-start gap-0.5 leading-normal tracking-[0.5px]">
      <div className="text-jncquoi-neutral-1000 flex w-full shrink-0 flex-col items-start gap-2">
        {vendor && (
          <p className="font-pp-neue-montreal w-full shrink-0 text-[10px] font-semibold uppercase">
            {vendor}
          </p>
        )}
        {title && (
          <p className="font-pp-neue-montreal w-full shrink-0 text-[12px] leading-[110%] text-ellipsis">
            {title}
          </p>
        )}
      </div>
      {price != null && (
        <p className="font-pp-neue-montreal text-jncquoi-neutral-700 w-full shrink-0 text-[12px]">
          {formatAmount(price, 'EUR', locale)}
        </p>
      )}
    </div>
  );
}
